
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";
import { UserCardDto } from "@/api/appService";
import EditUserCard from "./components/edit-userCard.vue";
import enumFilter from "@/mixins/filters/enums";
import { ElForm } from "element-ui/types/form";
import { UserManager } from "oidc-client";
import UseUserCard from "./components/use-userCard.vue";
import UserCardLogs from "./components/userCardLogs.vue";
import filter from "@/utils/filter";
import RefundDialog from "@/components/RefundDialog/index.vue";
import PagedTableView from "@/components/PagedTableView/index.vue";
enum UserCardStatus {
  Canceled = -1,
  Refunding = 2,
  Freeze = 3,
  Payed = 4
}

interface UserCardQueryForm  {
  /**  */
  keyword?: string;
  /**  */
  userId?: number;
  /**  */
  cardId?: number;
  /**  */
  cardSkuId?: number;
  /** 是否要获取当前可用的会员卡(未过期的，还有余额的) */
  isGetAvailable?: boolean;
  /**  */
  sorting?: string;
  /**  */
  skipCount?: number;
  /**  */
  maxResultCount?: number;
  from?:string
};

@Component({
  name: "CardOrderList",
  components: {
    PagedTableView,
    EditUserCard,
    UseUserCard,
    UserCardLogs,
    RefundDialog
  },
  mixins: [enumFilter]
})
export default class CardOrderList extends Vue {
  @Ref() editForm!: EditUserCard;
  @Ref() useUserCard!: UseUserCard;
  @Ref() userCardLogs!: UserCardLogs;
  @Ref() refundDialog!: RefundDialog;
  get userCardStatus() {
    return UserCardStatus;
  }

  tableItems: UserCardDto[] = [];
  userId:number| undefined = 0;
  queryForm: UserCardQueryForm = {
    keyword: "",
    userId:0,
    cardId:0,
    maxResultCount:10,
    skipCount:0,
    sorting:'id desc'
  };

  async created() {
    if(this.$route.params.userId){
      this.userId = Number(this.$route.params.userId)
      this.queryForm.userId = this.userId;
    } else {
      this.userId = undefined;
    }

  }



  // 获取表数据
  fetchData(params:any) {
    return api.userCard.getAll(params);
  }

  formatCard(row: any) {
    return `${row.card.title}-${row.cardSku.title}`;
  }

  formatCreationTime(row: any) {
    return filter.formatDate(row.creationTime, undefined);
  }

  // 新建
  handleCreate() {
    (this.editForm as any).show = true;
  }

  handleUse(row: UserCardDto) {
    console.log(row);
    (this.useUserCard as any).userId = row.creatorUserId!;
    (this.useUserCard as any).show = true;
    (this.useUserCard as any).input = row;
  }

  // 编辑
  async handleEdit(index: number, row: UserCardDto) {
    (this.editForm as any).show = true;
    (this.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 冻结
  async handleFreeze(row: UserCardDto) {
    api.userCard
      .freeze({
        id: row.id,
        desc: `${this.$store.getters['user/name'] } 停用了此卡`
      })
      .then(res => {
        this.$message.success("冻结成功");
      });
  }

  // 重新启用
  async handleEnable(row: UserCardDto) {
    api.userCard
      .enable({
        id: row.id,
        desc: `${this.$store.getters['user/name'] } 重新启用了此卡`
      })
      .then(res => {
        this.$message.success("启用成功");
      });
  }

  // 删除
  async handleDelete(index: number, row: UserCardDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.userCard
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
    });
  }

  // 日志
  async handleLogs(row: UserCardDto) {
    await api.userCard.getLogs({ id: row.id }).then(res => {
      console.log(res);
      if (res.length) {
        (this.userCardLogs as any).logs = res;
        (this.userCardLogs as any).show = true;
      } else {
        this.$message.info("没有日志");
      }
    });
  }


  handelOnSaved(){

  }


  // 申请退款
  async handleRefund(item: UserCardDto) {
    console.log(this.refundDialog);
    (this.refundDialog as any).defaultValue = item.balance;
    (this.refundDialog as any).row = item;
    (this.refundDialog as any).show = true;
  }

  async refundSubmit(event: {
    row: UserCardDto;
    refundValue: number;
    desc: string;
    auditFlowId:string
  }) {
    console.log(event);
    await api.userCard
      .refund({
        id: event.row.id,
        totalPrice: event.refundValue,
        desc: event.desc,
        auditFlowId:event.auditFlowId
      })
      .then(res => {
        this.$message.success('退款申请已提交，请等待审核');
      });
  }
}
